export default __webpack_public_path__ + "static/media/1.40cb3139.png";